<template>
  <empty></empty>
</template>

<script>
export default {
  name: 'EventInfo'
}
</script>

<style scoped></style>
